import ItemBreakpoint from 'Custom/ItemBreakpoint/index';
import styles from './BackgroundImage.module.scss';
import Image from 'next/image';

const BackgroundImage = ({ children, image, mobileImage, imageClass }) => {
  return (
    <div className={styles.root}>
      {mobileImage ? (
        <ItemBreakpoint breakpoint="lg">
          <Image
            src={image}
            style={{ objectFit: 'cover' }}
            alt="test"
            placeholder="blur"
            className={imageClass}
          />
          <Image
            src={mobileImage}
            alt="test"
            style={{ objectFit: 'cover' }}
            placeholder="blur"
            className={imageClass}
          />
        </ItemBreakpoint>
      ) : (
        <Image
          src={image}
          style={{ objectFit: 'cover' }}
          alt="test"
          placeholder="blur"
          className={imageClass}
        />
      )}

      <div className={styles['content-wrap']}>{children}</div>
    </div>
  );
};

export default BackgroundImage;
